/* PKW GUTACHTER – Vorlauf zu maximal.js
   ==========================================================================
   NOTNAGEL. Diese Datei behebt einen Fehler in assets/maximal.js und
   gehoert geloescht, sobald der behoben ist. Was los ist:

   maximal.js beginnt mit einer einzigen 81.084 Zeichen langen Zeile, in
   der die Applaus-Tondatei als Base64 steht. Beim Herausloesen des
   Skripts aus der Entwurfsdatei ist der Inhalt des Elements
   <script id="applaus-daten"> mit in die Skriptdatei gerutscht.

   JavaScript liest davon die ersten 60 Zeichen als Variablennamen - denn
   danach folgt die Zeichenfolge // und alles Weitere gilt als Kommentar
   bis zum Zeilenende. Das Ergebnis ist ein Statement, das nichts tut,
   ausser eine Variable zu suchen, die es nicht gibt:

     Uncaught ReferenceError: SUQzBAAAAAAA...AAAA is not defined

   Der Fehler fliegt in der allerersten Zeile. Damit laeuft von maximal.js
   nichts mehr: keine Bewegungen, kein Konfetti - und vor allem wird der
   Vorhang nie weggezogen, der beim Laden ueber der Seite liegt. Die Seite
   ist dann vollstaendig da, aber unter einer blauen Flaeche begraben.

   Diese Datei definiert genau jene Variable, bevor maximal.js laeuft.
   Damit ist das erste Statement gueltig, der Fehler bleibt aus und der
   Rest der Datei - anime.js und die gesamte Bewegungsschicht - laeuft
   durch.

   RICHTIG BEHOBEN ist es erst, wenn die erste Zeile aus maximal.js
   verschwindet. Dann kann diese Datei geloescht und ihr Aufruf aus
   layout/theme.liquid entfernt werden. Der Applaus braucht die Daten
   nicht: maximal.js sucht sie im Dokument unter #applaus-daten, wo sie
   in diesem Theme nicht stehen; den Ton spielt max-nachtrag.js aus der
   Datei, die in den Theme-Einstellungen hinterlegt ist.
   ========================================================================== */
window.SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjYwLjE2LjEwMAAAAAAAAAAAAAAA = 0;